import { MoonLoader } from 'react-spinners';

interface ButtonProps {
  label: string;
  color?:
    | 'ERROR'
    | 'SUCCESS'
    | 'NEUTRAL'
    | 'RED'
    | 'WARNING'
    | 'SUCCESS'
    | 'NONE';
}

interface ConfirmationPropType {
  title: string;
  message: string | JSX.Element;
  isOpen: boolean;
  loading: boolean;
  confirmButtonStyle: ButtonProps;
  cancelButtonStyle?: ButtonProps;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal = (props: ConfirmationPropType) => {
  const {
    isOpen,
    message,
    title,
    onCancel,
    onConfirm,
    loading,
    confirmButtonStyle,
    cancelButtonStyle,
  } = props;

  const colors = {
    NONE: 'border-gray-400 bg-white',
    ERROR: 'bg-brandError-500',
    SUCCESS: 'bg-brandSuccess-500  text-white',
    NEUTRAL: 'bg-primary-700 text-white',
    RED: 'bg-brandRed-300  text-white',
    WARNING: 'bg-brandWarning-500',
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div
      data-testid="test-confirm-modal"
      className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-20"
    >
      <div className="flex-row content-center gap-x-4 rounded-b-md rounded-t-2xl bg-primary-700 px-1 pb-1">
        <h1
          id="confirm-modal-title"
          data-testid="test-confirm-modal-title"
          className="my-2 px-3 text-xl font-semibold text-white"
        >
          {title}
        </h1>

        <div className="w-96 rounded-md bg-white p-6">
          <span className="flex flex-col justify-center gap-y-5">
            {loading ? (
              <span
                data-testid="test-confirm-loading"
                className="flex h-full w-full flex-col items-center justify-center gap-y-3 p-5"
              >
                <MoonLoader size={80} color="#071D49" />
                <label className="mb-2 flex w-full flex-grow justify-center rounded-md text-center">
                  Loading...
                </label>
              </span>
            ) : (
              <>
                <label
                  data-testid="test-confirm-modal-message"
                  className="mb-2 flex w-full flex-grow rounded-md"
                >
                  {message}
                </label>
                <span className="flex flex-row items-center justify-end gap-x-2">
                  <button
                    data-testid="test-confirm-affirm-btn"
                    onClick={onConfirm}
                    className={`rounded-md ${confirmButtonStyle && confirmButtonStyle.color ? colors[confirmButtonStyle.color] : colors['SUCCESS']} flex flex-row gap-x-2 px-4 py-2`}
                  >
                    <b>{confirmButtonStyle.label}</b>
                  </button>
                  <button
                    data-testid="test-confirm-cancel-btn"
                    onClick={onCancel}
                    className={`rounded-md border ${cancelButtonStyle && cancelButtonStyle.color ? colors[cancelButtonStyle.color] : colors['NONE']} px-4 py-2`}
                  >
                    <b>
                      {cancelButtonStyle ? cancelButtonStyle.label : 'Cancel'}
                    </b>
                  </button>
                </span>
              </>
            )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
